if(!window.gm) gm = {};
if(!gm.icons) gm.icons = {};
gm.icons.A = gm.icons.start = '//mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-waypoint-a.png&text=A&psize=16&font=fonts/Roboto-Regular.ttf&color=ff333333&ax=44&ay=48&scale=1';
gm.icons.B = gm.icons.end = '//mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-waypoint-b.png&text=B&psize=16&font=fonts/Roboto-Regular.ttf&color=ff333333&ax=44&ay=48&scale=1';
gm.icons[1] = gm.icons.driver = { url: '/pics/maps/spotlight-waypoints.png',
	size: [22, 40], origin: [0, 0], anchor: [11, 40] };
gm.icons[2] = gm.icons.passenger = { url: '/pics/maps/spotlight-waypoints.png',
	size: [22, 40], origin: [0, 40], anchor: [11, 40] };
gm.icons[3] = gm.icons.both = gm.icons.driver;
gm.icons.site = { url: '/pics/maps/icon_site.png',
	size: [22, 40], origin: [0, 0], anchor: [11, 40]  };
gm.icons.mysite = { url: '/pics/maps/icon_mysite.png',
	size: [22, 40], origin: [0, 0], anchor: [11, 40]  };
gm.icons.site2 = { url: '/pics/maps/icon_site.png',
	size: [22, 40], origin: [0, 0], anchor: [11+5, 40+2] };
gm.icons.mysite2 = { url: '/pics/maps/icon_mysite.png',
	size: [22, 40], origin: [0, 0], anchor: [11+5, 40+2] };
gm.icons.epsite = { url: '/pics/maps/icon_epsite.png',
	size: [22, 40], origin: [0, 0], anchor: [11, 40]  };
gm.icons.myepsite = { url: '/pics/maps/icon_myepsite.png',
	size: [22, 40], origin: [0, 0], anchor: [11, 40]  };
gm.icons.blue = 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png';
gm.icons.yellow = 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
gm.icons.green= 'https://maps.google.com/mapfiles/ms/icons/green-dot.png';

function PortalMap(options) {
	var self = this;
	for(var p in options) {
		if(p != 'postInit')
			self[p] = options[p];
	}
	self.postInit = [].concat(self.postInit||[], options.postInit||[]);
	gm.instances[self.id] = self;
	if(gm.loadAsync.loaded || !self.postponed) jQuery(self.init.bind(self));
}

PortalMap.prototype.defaultView = function defaultView() {
	if(!this.markerBounds.isEmpty()) {
		if(typeof this.autoMinZoom == 'number') {
			var self = this;
			self.minZoom = 0;
			google.maps.event.addListenerOnce(this.map, 'zoom_changed', function () { self.minZoom = self.map.zoom-self.autoMinZoom });
		}
		this.map.fitBounds(this.markerBounds);
		if(this.zoom && this.map.zoom > this.zoom) this.map.setZoom(this.zoom);
		this.map.panToBounds(this.markerBounds);
	}
	else if(this.center) {
		this.map.panTo(this.center);
		if(this.zoom && this.map.zoom != this.zoom) this.setZoom(this.zoom);
	}
	return this;
};

PortalMap.prototype.copyBackDate = function copyBackDate(complete, data, date) {
	if (this.dateSelector && complete) jQuery(this.dateSelector).val(date || '');
};

PortalMap.prototype.init = function init() {
	var self = this;
	if('string' == typeof self.onMarkerClick) self.onMarkerClick = window[self.onMarkerClick];
	var mapCanvas = jQuery(self.mapSelector), $parent = mapCanvas.parent('.map-canvas-parent');
	self.center = gm.LatLng(self.center);
	var mapOptions = { mapId: '227f48aee04f50a1' }; // mapTypeId: google.maps.MapTypeId.ROADMAP
	if(self.fullscreenControl) mapOptions.fullscreenControl = true;
	['zoom', 'streetView', 'mapType'].map(function(type) { var key = type+'ControlOptions'; if(self[key] && typeof self[key] == 'object') {
		for(var p in self[key]) {
			var value = self[key][p];
			if(p=='enabled') mapOptions[type+'Control'] = value;
			else {
				if(p == 'position') if(typeof value == 'string') value = google.maps.ControlPosition[value];
				if(value != null) {
					if(mapOptions[key] == null) mapOptions[key] = {};
					mapOptions[key][p] = value;
				}
			}
		}
	}});
	if(self.map) {
		self.version++;
		if(self.zoom) mapOptions.zoom = self.zoom;
		if(self.center) self.map.panTo(self.center);
		self.map.setOptions(mapOptions);
		var groups = self.groups || { '_' : self };
		var b = self.map.getBounds().toJSON();
		// smaller bounds rectangle, or map *will* zoom out
		self.markerBounds = gm.Bounds([(4*b.north+b.south)/5, (4*b.east+b.west)/5], [(b.north+4*b.south)/5, (b.east+4*b.west)/5]);
	}
	else {
		self.version = 0;
		$parent.width(self.width || mapCanvas.width()).height(self.height || $parent.height() > 20 && $parent.height() || $parent.width()*0.8);
		mapCanvas.width('100%').height('100%');
		mapOptions.zoom = self.zoom || 13;
		mapOptions.center = self.center || gm.LatLng([50.84624, 4.3536]);
		self.map = new google.maps.Map(mapCanvas[0], mapOptions);
		$parent.click(function() { self.map.setOptions({ scrollwheel: true }) }).mouseleave(function() { self.map.setOptions({ scrollwheel: false }) }).mouseleave();
		if(!self.minZoom) self.minZoom = 0;
		if(self.minZoom > self.maxZoom) self.minZoom = self.maxZoom; 
		google.maps.event.addListener(self.map, 'zoom_changed', function zoomChanged () {
			if(self.maxZoom && self.map.zoom > self.maxZoom) self.map.setZoom(self.maxZoom);
			else if(self.map.zoom < self.minZoom) self.map.setZoom(self.minZoom);
		});
		self.infoWindow = new google.maps.InfoWindow({ maxWidth: 550 });
		google.maps.event.addListener(self.infoWindow, "closeclick", function() { self.current = null; self.map.setClickableIcons(true); });
		google.maps.event.addListener(self.map, 'click', function() {
			self.current = null; self.infoWindow.close(); setTimeout(function() { self.map.setClickableIcons(true) }, 500)
		});
		if(document.all||document.documentMode) { // fix for MSIE
			function fix4msie() {
				var i, divs = self.map.getDiv().getElementsByTagName("div");
				for(i = 0; i < divs.length; i++) {
					var div = divs[i];
					if(div.style) {
						if(div.style.opacity=="0.01") div.style.opacity = 0;
						else if(div.style.filter=="alpha(opacity=1)") div.style.filter = "alpha(opacity=0)";
					}
				}
			}
			google.maps.event.addListenerOnce(self.map, "tilesloaded", fix4msie);
		}
		google.maps.event.addListener(self.map, 'mousedown', function(e) { if(self.timeout) { clearTimeout(self.timeout); self.timeout = null } });
		self.markerBounds = gm.Bounds(true);
		self.groups = { '_': { markers: [], markerClusterer: self.markerClusterer && (self.markerClusterer==true||self.markerClusterer.indexOf(null)>=0) && new MarkerClusterer(self.map, [], { maxZoom: self.maxZoom ? self.maxZoom-1 : 13, averageCenter: true }) } };
	}
	if(self.destinations) for(var i in self.destinations) { var marker = self.destinations[i] = gm.Marker(self.destinations[i]); self.markerBounds.extend(marker.position); marker.setMap(self.map) }

	if(self.points && self.points.length) {
		loadData(self.points, self.ignorePoints);
	}

	if(!self.version) if(!self.center&& !self.markerBounds.isEmpty()) self.map.fitBounds(self.markerBounds);

    if(self.dateChangeHandler && self.dateChangeHandler.dateSelector != self.dateSelector) {
        jQuery(document).off('change', self.dateChange.dateSelector, self.dateChangeHandler);
        delete self.dateChangeHandler;
    }
	if(self.dataSource) {
		if(!self.dataSourceCache) self.dataSourceCache = {};
		if (typeof self.dataSource == 'string') self.dataSource = { url: self.dataSource };
		if (self.dataSourceParams) self.dataSource.data = self.dataSourceParams;
		if(self.dateSelector && !self.dateChangeHandler) {
			self.dateChangeHandler = function dateChangeHandler() { self.restart({ dataSourceParams: { date: this.value }}) }
			self.dateChangeHandler.dateSelector = self.dateSelector;
			jQuery(document).on('change', self.dateSelector, self.dateChangeHandler);
		}
		self.dataSource.dataType = 'json';
		var key = self.dataSource.url + '?' + jQuery.param(self.dataSource.data||{}), data;
		if(data = self.dataSourceCache[key]) {
			if(data !== true) {
				window.setTimeout(function() {
					loadData(data.data);
					postInit(true, (self.points||[]).concat(data.data), data.date);
				});
			}
			null;
		}
		else {
			// console.log('ajax', key);
			self.dataSourceCache[key] = true;
			jQuery.ajax(self.dataSource).done(function(data) {
				if(data.status=='OK') {
					self.dataSourceCache[key] = data;
					if(!(self.dataSource.data && self.dataSource.data.date) && data.date) self.dataSourceCache[(key+'&date='+data.date).replace('?&','?')] = data;
					loadData(data.data);
					postInit(true, (self.points||[]).concat(data.data), data.date);
				}
				else {
					self.dataSourceCache[key] = false;
					self._data = data;
					if(window.console) console.warn(data);
					postInit(null, self.points||[]);
				}
			}).fail(function() {
				if(window.console) console.warn('Ajax call ' + key + ' failed');
				self.dataSourceCache[key] = false;
			});
		}
	}
	postInit(!self.dataSource, self.points||[]);

	return self;

	function loadData(points, ignorePoints) {
		var markerById = self.markerById || {}, groups = self.groups, bounds = self.markerBounds, sep = jQuery('<div>').html(' &ndash; ').text(), markerMap = self.markerClusterer ? null : self.map;
		
		function onPsMarkerClick(){
			var marker = this;
			var detail = marker.detail;
			var id = detail.psId;
			if(self.current != 'ps' + id) {
				self.current = 'ps' + id;
				var content = jQuery('<div>').append(jQuery('<h5>').text(detail.title||translations.infowindow_title||''), jQuery('<ul>').html(
					detail.rides.map(function(ride) { return jQuery('<li>', { 'class': 'ridedetail' }).append(jQuery('<a>	', { target: '_blank', href: ride.trId && ('/rides/ad/' + ride.trId + (ride.tmId && '/' + ride.tmId || '')) }).text(ride.from.label + sep + ride.to.label).prepend(ride.time ? jQuery('<span class="time pr-1">').text(ride.time).prepend($('<i class="fa fa-map-marker pr-1" aria-hidden="true">')) : null )) 
				}))).html() + (self.infoWindowFooter||'');
				self.infoWindow.close();
				self.infoWindow.setContent(content);
			}
			self.infoWindow.open(self.map, marker);
		}
		function onMarkerClick(){
			var marker = this;
			var detail = marker.detail;
			var div = jQuery('<div>').addClass(detail.group+'-name').attr('data-id', detail.id);
			if(detail.html) div.html(detail.html); else div.text(detail.name);
			var content = detail.html || jQuery('<div>').append(div).html();
			self.current = null;
			self.infoWindow.close();
			self.infoWindow.setContent(jQuery('<div>').append(div).html());
			self.infoWindow.open(self.map, marker);
		}
		for (var i = 0; i < points.length; i++) {
			var detail = points[i];
			if(detail){
				var id = detail.id, group = detail.group || '_';
				if(!id)
					if(detail.psId)
						id = 'ps'+detail.psId;
					else if(detail.group)
						id = detail.id = detail.group+'-'+detail[detail.group+'_id'];
				var markerOptions = jQuery.extend({ draggable: false, title: detail.name }, detail, { detail: detail, id: id, group: group, version: self.version }), marker = markerById[id];
				if(marker) {
					marker.setOptions(gm.markerOptions(markerOptions));
					google.maps.event.clearListeners(marker, 'click');
				}
				else {
					var marker = markerById[id] = gm.Marker(markerOptions);
					if(!self.markerClusterer) marker.setMap(markerMap);
				}
				if(detail.psId) {
					 if(detail.rides && detail.rides.length)
						google.maps.event.addListener(marker, 'click', onPsMarkerClick);
				}
				else if(detail.group && self.onMarkerClick)
					google.maps.event.addListener(marker, 'click', function() { self.onMarkerClick.call(this, self) });
				else if(detail.name)
					google.maps.event.addListener(marker, 'click', onMarkerClick);
				if(!groups[group]) groups[group] = { markers: [], markerClusterer: self.markerClusterer && (self.markerClusterer==true || self.markerClusterer.indexOf(group)>= 0) };
				groups[group].markers.push(marker);
				if(!ignorePoints) bounds.extend(marker.position);
			}
		}
		self.markerById = markerById;
		self.markerBounds = bounds;
		if(self.markerClusterer) {
			for(var p in groups) {
				if(groups[p].markerClusterer==true) {
					groups[p].markerClusterer = new MarkerClusterer(self.map, groups[p].markers, { gridSize: 40, maxZoom: null, imagePath: '/pics/maps/markerclusterer/'+p, zoomOnClick: false, averageCenter: true });
					(function(group) {
						google.maps.event.addListener(groups[p].markerClusterer, 'clusterclick', function(cluster) { if(self.map.zoom < self.maxZoom) { self.map.fitBounds(cluster.getBounds()) } else { self.map.setClickableIcons(false); clusterInfo(cluster) } });
						function clusterInfo(cluster) {
							self.clusterInfo = [ group, cluster ];
							var $content = jQuery('<div>').append(cluster.getMarkers().map(function(marker) { return jQuery('<div>').addClass(group+'-name').attr('data-id', marker.detail.id).text(marker.detail.name) }).sort(function(a, b) { return a.text() < b.text() ? -1 : 1 }));
							self.current = cluster.getCenter().toUrlValue();
							setTimeout(function() { 
								self.infoWindow.close();
								self.infoWindow.setContent($content.html());
								self.infoWindow.setPosition(cluster.getCenter());
								self.infoWindow.open(self.map);
								self.timeout = setTimeout(function() { self.timeout = null; self.infoWindow.open(self.map) }, 1500);
							}, 5);
						}
					})(p);
				}
				else {
					var included = {};
					var markers = groups[p].markers = groups[p].markers.filter(function(marker) {
						if(included[marker.id] || marker.group!=p) return false;  // duplicate or other group
						if(groups[p].keep || marker.version==self.version) return included[marker.id] = true;  // current or preserved
						marker.setMap(null); return false;  // obsolete
					});
					if(groups[p].markerClusterer) {
						var removelist = groups[p].markerClusterer.getMarkers().filter(function(marker) {
							if(!included[marker.id]) return true; return included[marker.id] = false;
						});
						groups[p].markerClusterer.addMarkers(markers.filter(function(marker) { return included[marker.id] }), true);  // don't redraw yet
						groups[p].markerClusterer.removeMarkers(removelist);    // and redraw
					}
					else {
						markers.map(function(marker) { marker.setMap(self.map) })
					}
				}
			}
		}
		else {
			if(!self.keep) {
				var included = {};
				self.markers = self.markers.filter(function(marker) {
					if(included[marker.id]) return false;  // duplicate
					if(marker.version==self.version) return included[marker.id] = true;  // current
					marker.setMap(null); return false;  // obsolete
				});
			}
		}
	}

	function postInit(complete /* , args */) {
		for(var i = 0; i < self.postInit.length; i++) {
			var fn = self.postInit[i];
			if(typeof fn == 'string') fn = self[fn] || window[fn];
			if(typeof fn == 'function') fn.apply(self, arguments);
		}
		if(complete) setTimeout(self.defaultView.bind(self), 100);
	}
}

PortalMap.prototype.restart = function restart(options) {
	var self = this;
	options.center = options.center;
	options.zoom = options.zoom;
	if(self.timeout) clearTimeout(self.timeout);
	self.infoWindow.close();
	PortalMap.call(self, options);
	return self;
}

PortalMap.prototype.setZoom = function setZoom(goal) {
	var self = this, zoom = this.map.getZoom(), inc = (zoom < goal) - (zoom > goal);
	if (inc) {
		google.maps.event.addListenerOnce(self.map, 'zoom_changed', function(event){
			setTimeout(function() { self.map.setZoom(goal) }, 80);
		});
		self.map.setZoom(zoom+inc);
	}
	return self;
}
